import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { GRADIENTS } from '../../utils/constants';
import { Button } from '../ui/Button';
interface BackgroundCustomizerProps {
  onClose: () => void;
}
export function BackgroundCustomizer({
  onClose
}: BackgroundCustomizerProps) {
  const {
    getThemeClasses,
    theme,
    background,
    setBackground,
    t
  } = useTheme();
  const themeClasses = getThemeClasses();
  const [selectedBg, setSelectedBg] = useState(background);
  const backgrounds = Object.entries(GRADIENTS.background).map(([key, gradient]) => ({
    id: key,
    name: t.backgroundCustomizer.backgrounds[key as keyof typeof t.backgroundCustomizer.backgrounds],
    gradient
  }));
  // Auto-apply background when changed
  useEffect(() => {
    if (selectedBg !== background) {
      setBackground(selectedBg);
    }
  }, [selectedBg]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-656">
      <motion.div initial={{
      scale: 0.9,
      y: 20
    }} animate={{
      scale: 1,
      y: 0
    }} exit={{
      scale: 0.9,
      y: 20
    }} onClick={e => e.stopPropagation()} className={`w-full max-w-2xl ${themeClasses.card} border ${themeClasses.border} rounded-2xl overflow-hidden shadow-2xl`} data-id="element-657">
        {/* Header */}
        <div className={`p-6 border-b ${themeClasses.border} flex items-center justify-between`} data-id="element-658">
          <h2 className={`text-2xl font-bold ${themeClasses.text}`} data-id="element-659">
            {t.backgroundCustomizer.title}
          </h2>
          <button onClick={onClose} className={`p-2 ${themeClasses.cardHover} rounded-lg transition-colors`} data-id="element-660">
            <XIcon className={`w-5 h-5 ${themeClasses.icon}`} data-id="element-661" />
          </button>
        </div>
        {/* Background Options */}
        <div className="p-6" data-id="element-662">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4" data-id="element-663">
            {backgrounds.map(bg => <button key={bg.id} onClick={() => setSelectedBg(bg.gradient)} className="relative group" data-id="element-664">
                <div className={`aspect-video rounded-xl bg-gradient-to-br ${bg.gradient} border-2 transition-all ${selectedBg === bg.gradient ? theme === 'neon' ? 'border-cyan-500 shadow-lg shadow-cyan-500/50' : 'border-purple-500 shadow-lg shadow-purple-500/50' : `${themeClasses.border} ${theme === 'neon' ? 'hover:border-cyan-500/40' : 'hover:border-purple-500/40'}`}`} data-id="element-665">
                  {selectedBg === bg.gradient && <div className="absolute inset-0 flex items-center justify-center" data-id="element-666">
                      <div className={`w-10 h-10 rounded-full ${theme === 'neon' ? 'bg-cyan-500' : 'bg-purple-500'} flex items-center justify-center shadow-lg`} data-id="element-667">
                        <CheckIcon className="w-6 h-6 text-white" data-id="element-668" />
                      </div>
                    </div>}
                </div>
                <p className={`${themeClasses.text} text-sm font-medium mt-2 text-center`} data-id="element-669">
                  {bg.name}
                </p>
              </button>)}
          </div>
          {/* Close button - removed Apply button since we auto-apply */}
          <Button variant="secondary" onClick={onClose} fullWidth data-id="element-670">
            {t.common.close || 'Close'}
          </Button>
        </div>
      </motion.div>
    </motion.div>;
}